import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
	palette: {
		primary: {
			main: '#FFC100',
			// main: '#548687',
		},
		secondary: {
			main: '#FBD561',
		},
		error: {
			main: red.A400,
		},
		// Matches the app theme (createwithpixels-app src/theme/color.tsx)
		text: {
			primary: '#FFFFFF',
			secondary: '#A6A6A6',
		},
		background: {
			default: '#333333',
			paper: '#333333',
		},
	},
	typography: {
		fontFamily: ['Poppins'].join(','),
	},
});

export default theme;
